/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect, useState } from 'react'
import { useForm  } from 'react-hook-form';
import { LABEL_BTN_CANCEL } from 'src/constants/constant';
import { getCampaignDetailsById } from 'src/services/campaignService';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import '../Styles/muiglobal.css';
import CustomTooltip from '../CustomTooltip/CustomTooltip';
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { HelpCircleIcon } from '@hugeicons-pro/core-stroke-rounded';


// import MainLayout from '../Layouts/Mainlayout';

interface PropsType {
    id?: number;
}

interface PropsType {
    closeModal: () => void;
    refreshPage: () => void;
}

interface ApiResponse {
    status: number;
    data: {
        data: CampaignInputs[];
    };
}

export interface CampaignInputs {
    campaignId: number;
    clientId: number;
    groupId: number;
    brandId: number;
    templateId: number;
    name: string;
    description: string | null;
    startOn: string; // ISO date string
    endOn: string; // ISO date string
    isActive: boolean;
    isDeleted: boolean;
    copyCount: number;
    parentId: number;
    token: string;
    createdBy: number;
    createdOn: string; // ISO date string
    updatedBy: number | null;
    updatedOn: string | null; // ISO date string
    unopenedResendDayGap: number;
    resendMaxLimit: number;
    doNotRepeatEmailDays: number;
    emailSentWebhookURL: string;
    emailSentWebHookRequestBody: string;
  }
  


const APIInformation = ({ id, closeModal }: PropsType): JSX.Element => {

    const [campaignData, setCampaignData] = useState<CampaignInputs>()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const { setValue } = useForm();
    
    useEffect(() => {
            // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
            const fetchWebhookData = async () => {
                try {
                    const editWebhookIdNumber = id;
                    if (editWebhookIdNumber == null) return;
                    setIsLoading(true)
                    const res: ApiResponse = await getCampaignDetailsById(editWebhookIdNumber);
                    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                    if (res.status === 200 && res.data.data) {
                        const campaign = res.data.data[0]; // Extract the first campaign from the array
                        setCampaignData(campaign);
                        // Set form values
                        setValue("name", campaign.name);
                        const fullUrl = `${window.location.origin}${campaign.emailSentWebhookURL}`;
                        setValue("emailSentWebhookURL", fullUrl);
                    }
                } catch (error) {
                    console.error("Error fetching campaign data:", error);
                    NotificationManager.error("Error loading campaign data");
                } finally {
                    setIsLoading(false)
                }
            };
    
            void fetchWebhookData();
        }, [id, setValue]);

    return (
        <React.Fragment>
            {
                isLoading ?
                    <div className='flex justify-center items-center relative '><span className="loading loading-spinner text-primary"></span></div> :
                    <>
                        <div className="px-[16px] pt-[10px]">
                            <div className="grid">
                                {/* Campaign Name */}
                                <div className="mb-[20px] w-full relative">
                                    <div className="border border-inputborder bg-[#f5f5f5] text-center text-[18px] font-semibold rounded-md p-[7px] text-muted">
                                        {campaignData?.name}
                                    </div>
                                </div>

                                {/* API Endpoint */}
                                <div className="mb-8">
                                    <h3 className="text-[16px] font-semibold text-muted">API Endpoint</h3>
                                    <div className="flex items-center gap-2 mt-1">
                                        <p
                                            className="text-muted break-all">
                                            {campaignData?.emailSentWebhookURL}
                                        </p>
                                    </div>
                                </div>

                                {/* Sample Request */}
                                <div>
                                    <h3 className="text-[16px] font-semibold flex items-center gap-2" style={{ fontWeight: 600, fontFamily: "Manrope, sans-serif", margin: 0 }}>API Request 
                                        <CustomTooltip title="This is a sample request format used for API calls." placement="bottom" arrow={false}>
                                            <HugeiconsIcon
                                                icon={HelpCircleIcon}
                                                size={18}
                                                color="#3A3A3A"
                                                strokeWidth={0.2}
                                            />
                                        </CustomTooltip>
                                    </h3>
                                    <div className="bg-[#f5f5f5] p-3 rounded-md mt-1 text-sm font-mono whitespace-pre-wrap">
    {(campaignData?.emailSentWebHookRequestBody != null) ? (
        <pre>
            {(() => {
                try {
                    // Ensure the input is a valid JSON string
                    const formattedJson = JSON.stringify(JSON.parse(campaignData.emailSentWebHookRequestBody.replace(/'/g, '"')), null, 2);
                    return formattedJson;
                } catch (error) {
                    console.error("Invalid JSON format:", error);
                    return "Error: Invalid JSON format received from API.";
                }
            })()}
        </pre>
    ) : (
        <span>No data available</span>
    )}
</div>
                                </div>
                            </div>
                        </div>

                        <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
                            <div className="w-full relative col-span-3">
                                <button type='button' className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#e0e0e0] hover:border-[#e0e0e0] disabled:bg-[#f0f0f0] disabled:text-muted" disabled={isLoading} onClick={closeModal}>{LABEL_BTN_CANCEL}</button>
                            </div>
                            <div className="w-full relative col-span-3">
                                <button type="button" className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]" disabled={isLoading} onClick={closeModal}>{!isLoading ? 'Close' : <span className="loading loading-spinner loading-xs text-white"></span>}</button>
                            </div>
                        </div>
                    </>
            }
        </React.Fragment>

    )
}

export default APIInformation